import React from "react";
import { FeaturedThought } from "../components/FeaturedThought";
import { Hero } from "../components/Hero";
import { ProjectsSection } from "../components/ProjectsSection";
import { ReceiptsSection } from "../components/ReceiptsSection";
import { usePageTitle } from "../hooks/usePageTitle";
export function Home() {
  usePageTitle();
  return <main id="main-content" tabIndex={-1} data-id="element-436" data-mp="2x4wnn60xwv5p">
      <Hero data-id="element-437" data-mp="1zih13ptnp7ba" />
      <ProjectsSection data-id="element-438" data-mp="1ziqqpcashcgg" />
      <FeaturedThought data-id="element-439" data-mp="1zjigg6hpgfyt" />
      <ReceiptsSection data-id="element-440" data-mp="1zkaavdzkg7ni" />
    </main>;
}